import { o_util } from "../../common/namespaces";
import { assignNamespace } from "../../common/assignNamespace.js";
import { exists } from "./exists";
import { get } from "./get";
import { remove } from "./remove";
import { set } from "./set.js";
import { SAMESITE_VALUES } from "./utils";

export * from "./utils";
export * from "./exists";
export * from "./get";
export * from "./remove";
export * from "./set";

assignNamespace(o_util, "cookie", { SAMESITE_VALUES, exists, get, remove, set });
